import { React } from "../../library";

const Footer = () => (
    <footer
        className="py-4 bg-dark text-white-50 _sticky_footer">
        <div className="container text-center">
            <small>Copyright &copy; ukart</small>
        </div>
    </footer>
);

export default Footer;